import React, { useEffect, useState } from 'react';
import { Text, View, ScrollView, ImageBackground, Dimensions } from 'react-native';
import { globalStyles } from 'Theme';
import { Device } from 'DeviceUtils';
import type { StyleMap } from 'Types';
import ModalHeader from '../ModalHeader';
import Button from '../Button';
import Icon from '../Icon';
import { ENTITLEMENTS_BACKGROUND_PORTAIT, ENTITLEMENTS_BACKGROUND_LANDSCAPE } from 'Options';

import defaultStyles from './EntitlementsModal.jss';
import CategoriesContainer from './CategoriesContaner';

interface EntitlementsnModalProps {
    icon?: string;
    header?: string;
    message?: string | Array<string>;
    confirmLabel?: string;
    cancelLabel?: string;
    webString: string;
    storeString: string;
    mobileString: string;
    onConfirm?: () => void;
    onCancel?: () => void;
    onClose?: () => void;
    mode?: string | null;
    logo?: string;
    style?: StyleMap;
}

// eslint-disable-next-line import/prefer-default-export
export const EntitlementsModal = ({
    header,
    message,
    icon,
    confirmLabel,
    webString,
    storeString,
    mobileString,
    onCancel,
    onConfirm,
    onClose,
    mode
}: EntitlementsnModalProps): JSX.Element => {
    const isLandscape = mode === 'landscape';
    const numberOfLines = Device.isWeb ? 0 : 50;
    const [moveCloseButton, setMoveCloseButton] = useState(false);

    const onCloseCallback = onClose && typeof onClose === 'function' ? onClose : onCancel;

    useEffect(() => {
        setMoveCloseButton(Device.height > 1000 ? true : false);
        const handleResize = () => {
            setMoveCloseButton(Dimensions.get('window').height > 1000 ? true : false);
        };
        const subscription = Dimensions.addEventListener('change', handleResize);
        return () => {
            subscription?.remove();
        };
    }, []);

    return (
        <View style={[defaultStyles.mainContainer, {
            flex: 1
        }]}>
            <ImageBackground
                source={
                    Device.isPhone
                        ? ENTITLEMENTS_BACKGROUND_PORTAIT
                        : ENTITLEMENTS_BACKGROUND_LANDSCAPE
                }
                style={defaultStyles.container}
                resizeMode="contain"
            >
                {onCloseCallback && (
                    <ModalHeader
                        style={
                            isLandscape || Device.isWeb
                                ? {
                                    iconContainer: {
                                        ...defaultStyles.iconContainerLandscape,
                                        top: moveCloseButton
                                            ? '20%'
                                            : defaultStyles.iconContainerLandscape.top
                                    }
                                }
                                : {}
                        }
                        onPress={onCloseCallback}
                    />
                )}
                <ScrollView
                    contentContainerStyle={[
                        defaultStyles.innerContainer,
                        { justifyContent: 'center', alignItems: 'center' }
                    ]}
                >
                    <View
                        style={{
                            flexDirection: 'row',
                            justifyContent: 'center',
                            alignItems: 'center',
                            flexShrink: 1,
                            flexWrap: 'wrap'
                        }}
                    >
                        {/* {logo && <Icon style={defaultStyles.logo} name={logo} />} */}
                        <View
                            style={[
                                defaultStyles.titleContainer,
                                isLandscape && defaultStyles.titleContainerLandscape
                            ]}
                        >
                            {icon && (
                                <Icon
                                    style={[
                                        defaultStyles.infoIcon,
                                        isLandscape && defaultStyles.infoIconLandscape
                                    ]}
                                    name={icon}
                                />
                            )}
                            {header && <Text style={defaultStyles.title}>{header}</Text>}
                        </View>
                    </View>
                    <Text style={globalStyles.primaryTextColor} numberOfLines={numberOfLines}>
                        {message}
                    </Text>
                    <CategoriesContainer
                        webString={webString}
                        storeString={storeString}
                        mobileString={mobileString}
                    />
                    <View
                        style={[
                            defaultStyles.buttonsContainer,
                            defaultStyles.buttonContainerOneButton,
                            isLandscape && defaultStyles.landscapeButtonsContainer
                        ]}
                    >
                        {confirmLabel && (
                            <Button
                                style={{ button: defaultStyles.button }}
                                title={confirmLabel}
                                onPress={onConfirm}
                                testID="confirm_button"
                            />
                        )}
                    </View>
                </ScrollView>
            </ImageBackground>
        </View>
    );
};
